//Component: AttachementsTC
//Description: This component is used to handle Attachements related to Testing and Commissioning

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import axios from 'axios';
import { randomId } from '@mui/x-data-grid-generator';
import { Box, Button, Grid, Typography, useMediaQuery, Modal } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import { getAuthToken } from "../../utility/tokenUtility";
import { MasterGraph, FemsGraph, BemsGraph } from '../../utility/apiURLS';
import { useDispatch } from "react-redux";
import AssetFooter from "../commoncomponents/AssetFooter";
import TCActionsTypes from "../../redux/actions/TestingCommission/TCActionTypes";
import { DispatchAction, setBasicDetailsFields } from "../../redux/actions/TestingCommission/dispatchActions";
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import CustomAlert from '../userlocationcomponents/CustomAlert';
import { tcCreateUpdateRepository } from '../../api/repositories/TestingandCommissioning/tcCreateUpdateRepository';
import { clearAttachmentDetails, gridValues, updateAssetSpecification, updateBasicDetails, updatePurchaseDetails } from '../../redux/actions/assetActions';
import dayjs from 'dayjs';
import ComponentHeader from '../commoncomponents/ComponentHeader';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomDatePicker from '../commoncomponents/CustomDatePicker';
import utils from "../../utility/utilities";
import Tcviewfile from './Tcviewfile';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { createRoot } from 'react-dom/client';
import Axios from 'axios';
import utilities from '../../utility/utilities';
import { useAccess } from '../../AccessContext';


const initialRow = {
    id: randomId(),
    file: null,
    fileName: '',
    fileType: '',
    size: '',
};


function AddRowButton(props) {

    const tcDetails = useSelector(state => state.TestingCommissionDetails.tcDetails);
    const isViewPage = tcDetails?.isViewMode;
    const handleClick = () => {
        props.onClick();
    };

    return (
        <Box sx={{ mt: 2, mb: 2 }}>
            {!isViewPage &&
                <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleClick}>
                    Add Row
                </Button>
            }
        </Box>
    );
}

export default function AttachmentTC({ hospitalcode, hospitalname, hospitalid, setAuthoriseTick }) {
    const accessData = useAccess();
    const accessFem = utilities.getScreenPermissions(accessData, "ENGM013");
    const accessBem = utilities.getScreenPermissions(accessData, "ENGM014");
    const accessFemAndBem = accessFem?.canCreate || accessBem?.canCreate;
    const location = useLocation();
    //get the stepper value from redux
    const { stepper } = useSelector(state => state.TestingCommissionDetails.stepper);
    //get the basic details from redux
    const basicDetails = useSelector(state => state.TestingCommissionDetails.basicDetails);
    //get the others details from redux
    const othersDetails = useSelector(state => state.TestingCommissionDetails.othersDetails);
    //get the tc id from redux
    const tcID = basicDetails && basicDetails.id;
    //get the common testing and comissioning details from redux  
    let tcDetails = useSelector(state => state?.TestingCommissionDetails?.tcDetails);
    let checkFields = tcDetails;
    tcDetails = (tcDetails?.id === '') ? location.state.tcDetails : tcDetails;
    //state declaration
    const [rows, setRows] = useState([initialRow]);
    const [error, setError] = useState({
        testingcommissioncompletedate: false,
        istestpassed: false,
        others: false
    });
    const [errorMessage, setErrorMessage] = useState({
        testingcommissioncompletedate: '',
        istestpassed: '',
        others: ''
    });
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isView, setIsView] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [gridApi, setGridApi] = useState(null);
    const [isAuthorizeEnabled, setAuthorizeEnabled] = useState(true);
    const [isConvertToAssetEnabled, setConvertToAssetEnabled] = useState(true);
    const [isRejectEnabled, setRejectEnabled] = useState(true);
    const [isVendorLogin, setIsVendorLogin] = useState(localStorage.getItem("roleName") === "Vendors" ? true : false);
    const [storeFileName, setStoreFileName] = useState([]);
    const [openAuthorizeDialog, setOpenAuthorizeDialog] = useState(false);
    const [openRejectDialog, setOpenRejectDialog] = useState(false);
    const [getByIdFiles, setGetByIdFiles] = useState([]);
    const [isAnyFilesAffected, setIsAnyFilesAffected] = useState(false);
    const [authorizeSuccessDialog, setAuthorizeSuccessDialog] = useState(false);
    const [submitConformationDialog, setSubmitConformationDialog] = useState(false);
    const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
    const [saveDialog, setSaveDialog] = useState(false);
    const [isDataChanged, setIsDataChanged] = useState(false);
    const [gridLoader, setGridLoader] = useState(false);
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const [deleteConfrimDialoug, setDeleteConfrimDialoug] = useState(false);
    const [currentId, setCurrentId] = useState('');
    const [financeAssetNoError, setFinanceAssetNoError] = useState(false);
    //varibale declaration
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [basicDetailsTC, setbasicDetailsTC] = useState(basicDetails || {});
    const tcstatusOptions = [
        { value: true, label: 'PASSED' },
        { value: false, label: 'FAILED' }
    ];
    const currentDate = utils.getCurrentDateFormatted("DD-MM-YYYY");
    const [isFilledAllMandatoryField, setIsFilledAllMandatoryField] = useState(false);
    const [statusChanged, setStatusChanged] = useState(false);

    const token = getAuthToken("id_token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const allowedFileExtensions = ['jpeg', 'jpg', 'png', 'xlsx', 'csv', 'pdf', 'doc'];

    console.log(basicDetails, "basicDetails");


    //get the tc details from redux
    // const tcDetails = useSelector(state => state.TestingCommissionDetails.tcDetails);
    const assetNo = (tcDetails?.femassetregisters?.length > 0 && tcDetails.femassetregisters[0]?.assetno) ||
        (tcDetails?.bemassetregisters?.length > 0 && tcDetails.bemassetregisters[0]?.assetno || tcDetails?.assetno);
    const isViewPage = tcDetails?.isViewMode;
    const statusId = (tcDetails?.femtestingcommissionstatusId || tcDetails?.bemtestingcommissionstatusId);
    const [isDisableAllfileds, setIsDisableAllfileds] = useState(statusId === 3 || statusId === 4 || statusId === 5 || statusId === 6);
    const statusArray = [
        { id: 1, value: 'open' },
        { id: 2, value: 'inprogress' },
        { id: 3, value: 'submitted' },
        { id: 4, value: 'completed' },
        { id: 5, value: 'authorized' },
        { id: 6, value: 'rejected' },
    ];
    const status = statusId ? statusArray?.find((item) => item?.id === statusId)?.value : '';

    const handlePreviousClick = () => {
        const data = 'Others';
        dispatch(DispatchAction(TCActionsTypes.PREVIOUS_PAGE, { ...stepper, currentPage: data }));
    };

    useEffect(() => {

        if (tcDetails?.isVendorLogin) {
            setIsVendorLogin(true);
        }

        if (tcDetails?.femtestingcommissionstatusId === 3 || tcDetails?.bemtestingcommissionstatusId === 3) {
            setIsSubmitEnabled(true); //if already in submitted states, disable the submit button
            setAuthorizeEnabled(false); //
            setRejectEnabled(false);
        }
        if (assetNo) {
            setIsSubmitEnabled(true);
            // setAuthorizeEnabled(true);
            // setRejectEnabled(true);
            setConvertToAssetEnabled(true);
        }
        if ((tcDetails?.femtestingcommissionstatusId === 2 || tcDetails?.bemtestingcommissionstatusId === 2) && assetNo) {
            setIsSubmitEnabled(false);
            setAuthorizeEnabled(true);
            setRejectEnabled(true);
        }
        if (tcDetails?.femtestingcommissionstatusId === 5 || tcDetails?.bemtestingcommissionstatusId === 5) {
            setIsSubmitEnabled(true);
            setAuthorizeEnabled(true);
            setRejectEnabled(true);
            setConvertToAssetEnabled(false);
        }
        if (tcDetails?.femtestingcommissionstatusId === 5 || tcDetails?.bemtestingcommissionstatusId === 5 && assetNo) {
            setIsSubmitEnabled(true);
            setAuthorizeEnabled(true);
            setRejectEnabled(true);
            setConvertToAssetEnabled(true);
        }


        if (tcDetails?.femtestingcommissionstatusId === 6 || tcDetails?.bemtestingcommissionstatusId === 6) {
            setIsSubmitEnabled(true);
            setAuthorizeEnabled(true);
            setRejectEnabled(true);
            setConvertToAssetEnabled(true);
        }

        if (isViewPage) {
            setConvertToAssetEnabled(true);
            setAuthorizeEnabled(true);
            setRejectEnabled(true);
            setIsSubmitEnabled(true)
        }

        if (!basicDetailsTC?.istestpassed?.value) {
            setConvertToAssetEnabled(true);
        } //disable the convert to asset button if test is not passed

        if (tcDetails?.femtestingcommissionstatusId === 5 && !assetNo) {
            setConvertToAssetEnabled(false);
        }

    }, [statusChanged])

    useEffect(() => {
        const fetchFiles = async () => {
            try {
                setGridLoader(true);
                const serviceType = basicDetails?.service?.label;
                const url = serviceType === "FEMS" ? `${FemsGraph}/api/TestingandCommission/GetTestingAttachmentsList/${tcID}` : `${BemsGraph}/api/TestingandCommission/GetTestingAttachmentsListbem/${tcID}`;
                const response = await axios.get(url, config);
                const fetchedFiles = response?.data || []; // Using optional chaining and default to empty array if undefined
                setGetByIdFiles(fetchedFiles);
                const fetchedRows = fetchedFiles?.map((file) => {
                    const filenameWithoutExtension = file?.documenttitle.split('.').slice(0, -1).join('.');
                    const fileNameWithExtension = file?.documenttitle;
                    const dotIndex = fileNameWithExtension.lastIndexOf('.');
                    const fileType = fileNameWithExtension.substring(dotIndex + 1);
                    // Calculate size in MB
                    const size = file?.filesize;
                    // Convert the file content to a Blob object
                    const blob = new Blob([file.content], { type: fileType });
                    blob.name = file.filename;
                    return {
                        id: file?.id,
                        file: blob,
                        fileName: filenameWithoutExtension || 'Unknown',
                        fileType: fileType?.toUpperCase(),
                        size: size,
                    };
                });
                fetchedFiles?.length > 0 ? setRows(fetchedRows) : setRows([initialRow]);
            } catch (error) {
                console.log('Error fetching files:', error);
            } finally {
                setIsAnyFilesAffected(false);
                setGridLoader(false);
            }
        };
        if (tcID) {
            fetchFiles();
        }
    }, [isAnyFilesAffected]);

    useEffect(() => {
        if (rows?.length > 0) return;
        else if (rows?.length === 0) {
            setRows([initialRow])
        }
    }, [rows])

    useEffect(() => {
        if (!basicDetailsTC?.istestpassed || !basicDetailsTC?.testingcommissioncompletedate) {
            setIsDisableAllfileds(false);
        }
    }, []);

    const checkConfrimDelete = async (row) => {
        const { id } = row
        const isFileStored = getByIdFiles?.some((item) => item.id === id);
        if (!isFileStored) {
            handleDeleteClick(id);
        } else {
            setDeleteConfrimDialoug(true);
            setCurrentId(id);
        }
    }

    const handleDeleteClick = async (id) => {
        const isFileStored = getByIdFiles?.find(file => file?.id === id);
        if (getByIdFiles?.length > 0 && isFileStored) {
            try {
                const serviceType = basicDetails?.service?.label;
                const url = serviceType === "FEMS" ? FemsGraph : BemsGraph;
                const femorbem = serviceType === "FEMS" ? "femtestingcommissionattachments" : "bemtestingcommissionattachments";
                const response = await axios.delete(`${url}/api/${femorbem}/${id}`, config);
                if (response.status >= 200 && response.status <= 204) {
                    const updatedRows = rows.filter((row) => row?.id !== id);
                    setRows(updatedRows);
                    const deletedRow = rows.find((row) => row?.id === id);
                    const updatedSelectedFiles = selectedFiles.filter((file) => file?.id !== deletedRow?.id);
                    setSelectedFiles(updatedSelectedFiles);
                    setIsAnyFilesAffected(true);
                }
            } catch (error) {
                console.log('Error deleting attachment:', error);
                setError({
                    ...error,
                    others: true
                });
                setErrorMessage({
                    ...errorMessage,
                    others: 'Error deleting attachment. Please try again.'
                });
            }
        } else if (rows?.length > 1) {
            // Filter out the row to be deleted
            const updatedRows = rows.filter((row) => row?.id !== id);
            setRows(updatedRows);

            // Find the file associated with the row to be deleted
            const deletedRow = rows.find((row) => row?.id === id);
            const fileToDelete = deletedRow?.file;

            // Filter out the file to be deleted from selectedFiles
            const updatedSelectedFiles = selectedFiles.filter((file) => file !== fileToDelete);
            setSelectedFiles(updatedSelectedFiles);
        } else if (rows?.length === 1) {

            const index = rows?.findIndex((item) => item?.id === id);
            if (!rows[index]?.fileName) {
                return; //do nothing
            } else {
                setRows([initialRow])
            }
        }

    };

    const handleAddRow = () => {
        const id = randomId();
        const newRow = {
            id,
            file: null,
            fileName: '',
            fileType: '',
            size: '',
        };
        setRows([...rows, newRow]);
    };

    const handleFieldChange = (value, field, isMandatoryField) => {
        // For fields that do not require a 'label' property
        if (value?.id) {
            setIsDataChanged(true);
        }
        if (dayjs(value, 'DD/MM/YYYY').isValid()) {
            setIsDataChanged(true);
        }
        setbasicDetailsTC(prevbasicDetailsTC => ({
            ...prevbasicDetailsTC,
            [field]: value
        }));

        // Update Redux state for basic details fields
        dispatch(setBasicDetailsFields({ [field]: value }));
        navigate(location.pathname, {
            state: {
                ...location.state,
                basicDetails: { ...location.state?.basicDetails, [field]: value, }
            }
        });
        setError(prevErrors => ({
            ...prevErrors,
            [field]: false  // Set error status to false for the field
        }));

        // Clear error message locally if needed
        setErrorMessage(prevErrorMessages => ({
            ...prevErrorMessages,
            [field]: ''  // Clear error message for the field
        }));
        if (isMandatoryField) {
            //make the error flag to false once user enters value
            setError((prev) => {
                const updatedError = {
                    ...prev,
                    [field]: false
                };

                const isAllFalse = Object.values(updatedError).every((value) => value === false);

                if (isAllFalse) {
                    setIsFilledAllMandatoryField(false);
                }

                return updatedError;
            });
            //clear the error message once the user enters value
            setErrorMessage((prev) => (
                {
                    ...prev,
                    [field]: ''
                }
            ));
        }
    };

    const changeStatus = async () => {
        const othersDetailsPayload = {
            class: getTrueKeys(othersDetails?.class),
            powercord: getTrueKeys(othersDetails?.powerCard),
            isdefibrillationproof: othersDetails?.proof ? othersDetails?.proof?.value : "",
            referenceno: getTrueKeys(othersDetails?.referenceNo),
            type: getTrueKeys(othersDetails?.type),
        };
        const payload = { ...basicDetails, ...othersDetailsPayload };
        const id = tcDetails?.id;
        const serviceType = basicDetails?.service?.label;
        const status = {
            Testcommissionstatus: 'inprogress',
            id: 2
        };
        const response = await tcCreateUpdateRepository.updateTC(payload, id, serviceType, status);
        if (response) {
            dispatch({ type: "SET_TC_FIELD_VALUES", payload: response });
            setStatusChanged(!statusChanged);
        }
    }

    // const handleFileChange = async (event, id) => {
    //     const file = event.target.files[0];
    //     if (!file) return;
    //     const fileName = file.name;

    //     const fileExtension = fileName.split('.').pop();
    //     if (file.size > 20 * 1024 * 1024) {
    //         setError({
    //             ...error,
    //             others: true
    //         });
    //         setErrorMessage({
    //             ...errorMessage,
    //             others: 'Error: File size exceeds 20 MB. Please select smaller files.'
    //         });
    //         return;
    //     }
    //     if (!allowedFileExtensions.includes(fileExtension)) {
    //         setError(prev => {
    //             return {
    //                 ...prev,
    //                 others: true
    //             }
    //         });
    //         // const allowedFileExtensions = ['jpeg', 'jpg', 'png', 'xlsx', 'csv', 'pdf', 'doc'];
    //         setErrorMessage(prev => {
    //             return {
    //                 ...prev,
    //                 others: 'Only JPEG, PDF, JPG, PNG, CSV, and XLSX files are allowed.'
    //             }
    //         });
    //         return;
    //     }
    //     const fileNameWithoutExtension = fileName?.replace('.' + fileExtension, '');
    //     // Find the existing file in selectedFiles or create a new entry
    //     let updatedSelectedFiles = [...selectedFiles];
    //     const fileIndex = updatedSelectedFiles.findIndex((file) => file.id === id);
    //     if (fileIndex > -1) {
    //         updatedSelectedFiles[fileIndex] = { id, file };
    //     } else {
    //         updatedSelectedFiles.push({ id, file });
    //     }
    //     setSelectedFiles(updatedSelectedFiles);

    //     const updatedRows = rows.map((row) => {
    //         if (row.id === id) {
    //             return {
    //                 ...row,
    //                 file,
    //                 fileName: fileNameWithoutExtension,
    //                 fileType: fileExtension.toUpperCase(),
    //                 size: (file.size / (1024 * 1024)).toFixed(2) + ' MB',
    //             };
    //         }
    //         return row;
    //     });

    //     setRows(updatedRows);
    //     setIsDataChanged(true);
    //     const storedStatus = ['submitted', 'completed', 'rejected']
    //     if (storedStatus?.includes(status)) {
    //         await changeStatus();
    //     }
    // };


    const handleFileChange = async (event) => {
        const files = Array.from(event.target.files);
        if (!files || files.length === 0) return;

        let newRows = [];
        let updatedSelectedFiles = [...selectedFiles];
        const allowedFileExtensions = ['jpeg', 'jpg', 'png', 'xlsx', 'csv', 'pdf', 'doc'];

        for (let file of files) {
            const fileName = file.name;
            const fileExtension = fileName.split('.').pop().toLowerCase();

            if (file.size > 20 * 1024 * 1024) {
                setError((prev) => ({ ...prev, others: true }));
                setErrorMessage((prev) => ({
                    ...prev,
                    others: 'Error: File size exceeds 20 MB. Please select smaller files.',
                }));
                return;
            }

            if (!allowedFileExtensions.includes(fileExtension)) {
                setError((prev) => ({ ...prev, others: true }));
                setErrorMessage((prev) => ({
                    ...prev,
                    others: 'Only JPEG, PDF, JPG, PNG, CSV, and XLSX files are allowed.',
                }));
                return;
            }

            const fileNameWithoutExtension = fileName.replace(`.${fileExtension}`, '');
            const id = randomId();

            newRows.push({
                id,
                file,
                fileName: fileNameWithoutExtension,
                fileType: fileExtension.toUpperCase(),
                size: (file.size / (1024 * 1024)).toFixed(2) + ' MB',
            });

            updatedSelectedFiles.push({ id, file });
        }

        // Filter out any placeholder rows with no files selected
        const filteredExistingRows = rows.filter((row) => row?.file);

        setRows([...filteredExistingRows, ...newRows]);
        setSelectedFiles(updatedSelectedFiles);
        setIsDataChanged(true);

        const storedStatus = ['submitted', 'completed', 'rejected'];
        if (storedStatus.includes(status)) {
            await changeStatus();
        }
    };

    const handleDownload = async (file) => {
        try {
            const isFileStored = getByIdFiles?.find((item) => item?.id === file?.id)
            if ((file && file?.file?.name || storeFileName?.length > 0) && isFileStored) { //this will handle edit time or store time download
                const fileName = file?.file?.name;
                const response = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${fileName}`, {
                    ...config,
                    responseType: 'blob'
                });

                if (response) {
                    const url = URL.createObjectURL(response.data);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = file?.fileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            } else { //this will handle initial time download
                if (file) {
                    // convert the file to blob
                    const fileToDownload = file?.file;
                    if (fileToDownload) {
                        const blob = new Blob([fileToDownload], { type: fileToDownload.type });
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = fileToDownload.name || 'downloaded_file';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        console.log('Invalid file object:', file);
                    }
                }
            }
        } catch (error) {
            console.log('Error downloading file:', error);
        }
    };


    const handleCloseDialog = () => {
        setOpenDialog(false);
    };


    const handlAuthorizeClick = () => {
        const isValid = validateForm();
        if (!isValid) {
            setIsFilledAllMandatoryField(true);
            return;
        }
        setOpenAuthorizeDialog(true);
    };

    const handleSave = async () => {
        const othersDetailsPayload = {
            class: getTrueKeys(othersDetails?.class),
            powercord: getTrueKeys(othersDetails?.powerCard),
            isdefibrillationproof: othersDetails?.proof ? othersDetails?.proof?.value : "",
            referenceno: getTrueKeys(othersDetails?.referenceNo),
            type: getTrueKeys(othersDetails?.type),
        };
        const payload = { ...basicDetails, ...othersDetailsPayload }
        const id = tcDetails?.id;
        const serviceType = basicDetails?.service?.label;
        const getStatus = statusId ? statusArray?.find((item) => item?.id === statusId)?.value : '';
        const status = {
            Testcommissionstatus: getStatus,
            id: statusId
        };
        const femorbem = serviceType === "FEMS" ? "femtestingandcommissionId" : "bemtestingandcommissionId";
        if (selectedFiles.length > 0) {
            try {
                const { storefileUploadResponse, storeFileNameArray } = await registerFiles();
                if (storefileUploadResponse && storefileUploadResponse.length > 0) {
                    const serviceType = basicDetails?.service?.label;
                    let storefileUploadResponseFinal = [];

                    for (let i = 0; i < storefileUploadResponse.length; i++) {
                        const file = storefileUploadResponse[i];
                        const documentTitle = storeFileNameArray.find((item) => item.id === file.fileName)?.filename;

                        if (documentTitle) {
                            const payload = {
                                filename: file.fileName,
                                filesize: file.fileSize,
                                filepath: "D:/IFAC-X/UploadFolder",
                                [femorbem]: basicDetails?.id,
                                documenttitle: documentTitle
                            };
                            try {
                                const response = await saveFilesToAttachment(serviceType, payload);
                                if (response) {
                                    storefileUploadResponseFinal.push(response);
                                } else {
                                    console.log("Error saving file:", file.fileName);
                                }
                            } catch (error) {
                                console.log('Error saving file:', error);
                            }
                        } else {
                            console.log("Document Title not found for file:", file.fileName);
                        }
                    }
                    if (storefileUploadResponseFinal?.length > 0 && storefileUploadResponseFinal?.length === storefileUploadResponse?.length) {
                        setSelectedFiles([]);
                        setIsAnyFilesAffected(true);
                        const isStatusAthorizedorRejected = checkStatus(status);
                        const response = await tcCreateUpdateRepository.updateTC({ ...payload, processingpercentage: 100 }, id, serviceType, isStatusAthorizedorRejected);
                        dispatch({ type: "SET_TC_FIELD_VALUES", payload: response });
                        if (response) {
                            setSaveDialog(true);
                        }
                    } else {
                        console.log("Error in uploading some files");
                    }
                } else {
                    console.log("No files registered");
                }
            } catch (error) {
                console.log('Error registering files:', error);
            }
        } else {
            const isStatusAthorizedorRejected = checkStatus(status);
            const response = await tcCreateUpdateRepository.updateTC({ ...payload, processingpercentage: 100 }, id, serviceType, isStatusAthorizedorRejected);
            dispatch({ type: "SET_TC_FIELD_VALUES", payload: response });
            if (response) {
                setSaveDialog(true);
            }
        }
    };

    function uuidv4(extension) {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }) + '.' + extension;
    };

    const registerFiles = async () => {
        const token = getAuthToken('id_token');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        let storeFileNameArray = [];
        let storeregsitredFilesResponse = [];
        let storefileUploadResponse = [];

        for (let i = 0; i < selectedFiles?.length; i++) {
            const formData = new FormData();
            const extension = selectedFiles[i]?.file?.name.split('.').pop();
            const fileName = uuidv4(extension); // generate a unique id
            formData.append('fileObj', selectedFiles[i]?.file, fileName); // append file with unique id as filename
            storeFileNameArray.push({ id: fileName, filename: `${selectedFiles[i]?.file?.name}`, selectedFileId: selectedFiles[i]?.id });

            try {
                const fileUploadResponse = await axios.post(`${MasterGraph}/api/fileupload`, formData, config);
                storeregsitredFilesResponse.push(fileUploadResponse.data);
                storefileUploadResponse.push(fileUploadResponse.data);
            } catch (error) {
                console.log('Error uploading file:', error.response ? error.response.data : error.message);
            }
        }
        setStoreFileName(storeFileNameArray);
        return { storefileUploadResponse, storeFileNameArray };
    };

    const saveFilesToAttachment = async (serviceType, payload) => {
        const url = serviceType === "FEMS" ? FemsGraph : BemsGraph;
        const femorbem = serviceType === "FEMS" ? "femtestingcommissionattachments" : "bemtestingcommissionattachments";
        const config = {
            headers: {
                Authorization: `Bearer ${getAuthToken('id_token')}`
            }
        };

        try {
            const response = await axios.post(`${url}/api/${femorbem}`, payload, config);
            return response.data;
        } catch (error) {
            console.log('saveFilesToAttachment Save error:', error);
        }
    };

    const getTrueKeys = (obj) => {
        return obj ? Object?.keys(obj)?.filter(key => obj[key])?.join(',') : '';
    };

    const checkStatus = (status) => {
        if (basicDetails?.isEditMode) {
            const id = tcDetails?.femtestingcommissionstatusId || tcDetails?.bemtestingcommissionstatusId;
            const statuses = {
                5: { Testcommissionstatus: 'Authorized', id: 5 },
                6: { Testcommissionstatus: 'Rejected', id: 6 }
            };
            return statuses[id] || status;
        }
        return status;
    };

    const setStatus = async (status) => {
        const othersDetailsPayload = {
            class: getTrueKeys(othersDetails?.class),
            powercord: getTrueKeys(othersDetails?.powerCard),
            isdefibrillationproof: othersDetails?.proof ? othersDetails?.proof?.value : "",
            referenceno: getTrueKeys(othersDetails?.referenceNo),
            type: getTrueKeys(othersDetails?.type),
        };
        const payload = { ...basicDetails, ...othersDetailsPayload, processingpercentage: 100 };
        const id = tcDetails?.id;
        const serviceType = basicDetails?.service?.label;
        const isStatusAthorizedorRejected = checkStatus(status);
        const response = await tcCreateUpdateRepository.updateTC(payload, id, serviceType, isStatusAthorizedorRejected);
        dispatch({ type: "SET_TC_FIELD_VALUES", payload: response });
        return response;
    };

    const validateForm = () => {
        let formIsValid = true;
        const errorStatus = { ...error };
        const newErrorMessages = { ...errorMessage };
        if (!basicDetailsTC?.istestpassed?.label) {
            formIsValid = false;
            errorStatus.istestpassed = true;
            newErrorMessages.istestpassed = 'T&C Status is required';
        }
        if (!basicDetailsTC?.testingcommissioncompletedate) {
            formIsValid = false;
            errorStatus.testingcommissioncompletedate = true;
            newErrorMessages.testingcommissioncompletedate = 'T&C Completed Date is required';
        }
        setError(errorStatus);
        setErrorMessage(newErrorMessages);
        return formIsValid;
    };

    const handleSubmitClick = async () => {
        const serviceType = basicDetails?.service?.label;
        const femorbem = serviceType === "FEMS" ? "femtestingandcommissionId" : "bemtestingandcommissionId";
        const isValid = validateForm();
        if (!isVendorLogin && !isValid) {
            setIsFilledAllMandatoryField(true);
            return;
        }
        if (selectedFiles.length > 0 && !isVendorLogin) {
            try {
                const { storefileUploadResponse, storeFileNameArray } = await registerFiles();
                if (storefileUploadResponse && storefileUploadResponse.length > 0) {
                    const serviceType = basicDetails?.service?.label;
                    let storefileUploadResponseFinal = [];

                    for (let i = 0; i < storefileUploadResponse.length; i++) {
                        const file = storefileUploadResponse[i];
                        const documentTitle = storeFileNameArray.find((item) => item.id === file.fileName)?.filename;

                        if (documentTitle) {
                            const payload = {
                                filename: file.fileName,
                                filesize: file.fileSize,
                                filepath: "D:/IFAC-X/UploadFolder",
                                [femorbem]: basicDetails?.id,
                                documenttitle: documentTitle
                            };
                            try {
                                const response = await saveFilesToAttachment(serviceType, payload);
                                if (response) {
                                    storefileUploadResponseFinal.push(response);
                                } else {
                                    console.log("Error saving file:", file.fileName);
                                }
                            } catch (error) {
                                console.log('Error saving file:', error);
                            }
                        } else {
                            console.log("Document Title not found for file:", file.fileName);
                        }
                    }
                    if (storefileUploadResponseFinal?.length > 0 && storefileUploadResponseFinal?.length === storefileUploadResponse?.length) {
                        const status = {
                            Testcommissionstatus: 'Submitted',
                            id: 3
                        };
                        setIsAnyFilesAffected(true);
                        const response = await setStatus(status);
                        const responseStatus = response?.femtestingcommissionstatusId || response?.bemtestingcommissionstatusId
                        if (responseStatus != 4 && responseStatus != 5 && response) {
                            setSelectedFiles([]);
                            setAuthorizeEnabled(false);
                            setRejectEnabled(false);
                            // setOpenDialog(true); //for file conformation
                            setSubmitConformationDialog(true);
                            setIsSubmitEnabled(true);
                            dispatch({ type: "SET_TC_FIELD_VALUES", payload: response });
                        }
                    } else {
                        console.log("Error in uploading some files");
                    }
                } else {
                    console.log("No files registered");
                }
            } catch (error) {
                console.log('Error registering files:', error);
            }
        } else {
            const status = {
                Testcommissionstatus: 'Submitted',
                id: 3
            };
            const response = await setStatus(status);
            const responseStatus = response?.femtestingcommissionstatusId || response?.bemtestingcommissionstatusId
            if (responseStatus != 4 && responseStatus != 5 && response) {
                setAuthorizeEnabled(false);
                setRejectEnabled(false);
                setSubmitConformationDialog(true);
                setIsSubmitEnabled(true);
                dispatch({ type: "SET_TC_FIELD_VALUES", payload: response });
            }
        }
    };

    const handlConvertToAssetClick = () => {
        const TCDetails = basicDetails;
        //set the related fields to Asset Basic Details
        // default values for basic details
        const intialBaiscDetails = {
            rentalStatus: { label: "No", key: "option2", default: true }, //setting the default value
            tcNo: { label: tcDetails?.testingcommissionno || '', key: tcDetails?.testingcommissionno || '', id: TCDetails?.id },
            tcOldNo: "",
            assetClassification: {
                key: "option1",
                id: 1,
                label: "Asset",
                isloanerasset: false,
            }, //setting the default value for asset classification when rentalStatus is No
            financeAssetNo: TCDetails?.financeassetno,
            assetDescription: TCDetails?.assetdesc || "",
            typecode: "",
            isTCField: true,
            typeCodeDescription: { id: TCDetails?.typecode?.id, label: TCDetails?.typecode?.value, value: TCDetails?.typecode?.label } || "",
            locationName: { ...TCDetails?.location } || "",
            locationNo: "",
            userDepartment: "",
            departmentDescription: "",
            criticality: { ...TCDetails?.criticality } || "",
            workGroup: { key: "option", ...TCDetails?.workgroup },
            ppmRequired: { label: "Yes", key: "option1", default: true }, //setting the default value
            ppmStatus: "",
            parentAssestNo: "",
            description: "",
            reason: "",
            isauthorized: false,
            assetValue: "",
            oldAssetNo: "",
            id: "",
        };

        const initailAssetSpecification = {
            make: "",
            brand: "",
            model: TCDetails?.model || "",
            serialNo: TCDetails?.serialno || "",
            engineNo: "",
            chassisNo: TCDetails?.chassisno || "",
            manufacturer: TCDetails?.manufacturer || "",
            registrationNo: TCDetails?.registerno || "",
            capacity: "",
            assetStatus: {
                label: "Functioning ",
                key: "option1",
                default: true,
                id: 1,
            },
            lifeSpan: TCDetails?.lifespan || "",
            depreciationValue: "",
            buildupArea: "",
            footPrint: "",
            landArea: "",
            isDataSetInEditMode: false,
        };

        const warrantyStartDate = TCDetails?.warrantystartdate
            ? dayjs(TCDetails.warrantystartdate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss")
            : "";

        const warrantyEndDate = TCDetails?.warrantyexpirydate
            ? dayjs(TCDetails.warrantyexpirydate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss")
            : "";

        const commissioningDate = TCDetails?.testingcommissioncompletedate
            ? dayjs(TCDetails.testingcommissioncompletedate, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss")
            : "";


        const initialPurchaseDetails = {
            warrantyStartDate,
            warrantyEndDate,
            commissioningDate,
            warranty: "",
            vendor: { ...TCDetails?.vendorname } || "",
            purchaseOrderNo: TCDetails?.purchaseorderno || "",
            purchaseCost: TCDetails?.purchaseprice || "",
            accessories: "",
            cumulativePartCost: null,
            cumulativeLabourCost: null,
            lastUnscheduledWorkOrder: "",
            lastScheduledWorkOrder: "",
            assetTransferCategory: "",
            purchaseFlag: "",
            assetTransferDepartment: "",
            underWarrenty: TCDetails?.isunderwarranty || false,
            isDataSetInEditMode: false,
            isTCFieldSet: true,
        };

        const initialAttachmentDetails = [];
        const isAssetCreation = true; //this flag for showing the underwarranty
        const mergedPurchaseDetails = {
            ...initialPurchaseDetails,
            isAssetCreation,
        };
        dispatch(gridValues({ values: {}, isEdit: false, isView: false }));
        dispatch(updateBasicDetails("UPDATE_BASIC_DETAILS", intialBaiscDetails));
        dispatch(updateAssetSpecification("UPDATE_ASSET_SPECIFICATION", initailAssetSpecification));
        dispatch(updatePurchaseDetails("UPDATE_PURCHASE_DETAILS", mergedPurchaseDetails));
        dispatch(clearAttachmentDetails("CLEAR_ATTACHMENT_DETAILS", initialAttachmentDetails));
        if (basicDetails?.service?.label === 'FEMS') {
            dispatch({ type: "SERVICE_TYPE", payload: "/assetsFEM" });
            navigate('/assetsFEM/registration');
        } else {
            dispatch({ type: "SERVICE_TYPE", payload: "/assetsBEM" });
            navigate('/assetsBEM/registration');
        }
    };
    const handlRejectClick = () => {
        setOpenRejectDialog(true);
    };

    const conformAuthorize = async () => {

        // if (basicDetails?.financeassetno === "") {
        //     setOpenAuthorizeDialog(false);
        //     setFinanceAssetNoError(true);
        //     return
        // }


        const status = {
            Testcommissionstatus: 'Authorized',
            id: 5
        };
        const response = await setStatus(status);
        if (response) {
            setIsDisableAllfileds(true);
            setOpenAuthorizeDialog(false); //close the confirmation dialog
            setAuthorizeEnabled(true); //disable the authorize button
            setRejectEnabled(true); //disable the reject button
            // here i haved checked one more conditon with assetNo 
            if (!basicDetailsTC?.istestpassed?.value || assetNo) { // if test is failed or already having asset no then convert to asset button should be disabled
                setConvertToAssetEnabled(true);
            }
            else if (assetNo) { //if there is any asset already created then convert to asset button should be disabled
                setConvertToAssetEnabled(true);
            } else {
                setConvertToAssetEnabled(false);
            }
            setAuthoriseTick(1);
            setAuthorizeSuccessDialog(true);
        }
    }

    const conformReject = async () => {
        const status = {
            Testcommissionstatus: 'Rejected',
            id: 6
        };
        const response = await setStatus(status);
        if (response) {
            setOpenRejectDialog(false); //close the confirmation dialog
            setAuthorizeEnabled(true); //disable the authorize button
            setRejectEnabled(true); //disable the reject button
            setConvertToAssetEnabled(true); //disable the convert to asset button when rejected
        }
    }

    const handleDownloadClick = async (event, file) => {
        event.preventDefault();
        await handleDownload(file);
    };

    const handleDownloadPDF = async () => {
        const servicetype = basicDetailsTC?.service?.label;
        const id = tcDetails?.id;
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            let response;
            if (servicetype === "FEMS") {
                response = await Axios.get(`${FemsGraph}/api/TestingandCommission/GetDownloadreporttandclistfem/${id}`, config);
                console.log("FEMS API response:", response); // Log the FEMS response
            } else {
                response = await Axios.get(`${BemsGraph}/api/TestingandCommission/GetDownloadreporttandclistbem/${id}`, config);
                console.log("BEMS API response:", response); // Log the BEMS response
            }

            if (response && response.data) {
                await downloadPDF(response.data);
            }
        } catch (error) {
            console.log("Error downloading the report:", error);
        }
    }


    const downloadPDF = async (data) => {
        setIsView(false);
        const printRef = document.createElement("div");
        document.body.appendChild(printRef);
        printRef.style.position = "absolute";
        printRef.style.top = "-9999px"; // Move it off-screen
        printRef.style.left = "-9999px"; // Move it off-screen
        printRef.style.zIndex = "999"; // Set desired z-index

        const padding = 1;
        const contentWidth = 210 - 2 * padding;
        const contentHeight = 297 - 2 * padding;

        const tcViewComponent = (
            <Box
                sx={{
                    padding: '10px',
                    margin: '0',
                    width: `${contentWidth}mm`,
                    height: `${contentHeight}mm`,
                    backgroundColor: '#fff',
                }}
            >
                <Tcviewfile data={data} />
            </Box>
        );

        const root = createRoot(printRef);
        root.render(tcViewComponent);

        try {

            await new Promise((resolve) => setTimeout(resolve, 500));


            const canvas = await html2canvas(printRef, {
                scale: 2,
                useCORS: true,
                scrollX: 0,
                scrollY: 0,
                windowWidth: 210 * 3.7795275591,
                windowHeight: 297 * 3.7795275591,
            });

            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF({
                orientation: 'p',
                unit: 'mm',
                format: 'a4',
            });

            const imgWidth = 210 - 2 * padding;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;


            const initialY = padding;
            let heightLeft = imgHeight;
            let position = initialY;


            pdf.addImage(imgData, 'PNG', padding, position, imgWidth, imgHeight);
            heightLeft -= (pdf.internal.pageSize.height - padding * 2);

            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', padding, position, imgWidth, imgHeight);
                heightLeft -= (pdf.internal.pageSize.height - padding * 2);
            }

            pdf.save("Commissioning_Report.pdf");
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {

            document.body.removeChild(printRef);
        }
    };


    return (
        <>
            <ComponentHeader
                mainHeader={"Attachments"}
                subHeader={"Please attach the required files."}
                assetvalue={tcDetails?.testingcommissionno}
                statusType={status}
            />
            <form style={{ position: 'relative' }}>

                <Grid container direction="column" style={{ width: '100%' }}>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <AddRowButton onClick={handleAddRow} />
                    </Grid>
                    <CustomAgGrid
                        rows={rows}
                        isLoading={gridLoader}
                        columns={[
                            {
                                field: 'file',
                                headerName: 'File',
                                flex: 1,
                                minWidth: isSmallScreen ? 150 : 200,
                                cellRenderer: (params) => (
                                    <Button variant="outlined" component="label" disabled={isViewPage || (params.value?.name ? true : false)}>
                                        {params.value?.name !== undefined ? 'File Uploaded' : 'Upload File'}
                                        <input
                                            type="file"
                                            hidden
                                            multiple
                                            onChange={(event) => handleFileChange(event)}
                                        />
                                    </Button>
                                ),
                            },
                            {
                                field: 'fileName',
                                headerName: 'File Name',
                                flex: 1,
                                editable: true,
                                minWidth: isSmallScreen ? 80 : 120,
                            },
                            {
                                field: 'fileType',
                                headerName: 'File Type',
                                flex: 1,
                                editable: true,
                                minWidth: isSmallScreen ? 80 : 120,
                            },
                            {
                                field: 'size',
                                headerName: 'Size',
                                flex: 1,
                                editable: true,
                                minWidth: isSmallScreen ? 80 : 120,
                            },
                            {
                                field: 'actions',
                                type: 'actions',
                                headerName: 'Actions',
                                flex: 1,
                                minWidth: 160,
                                cellClassName: 'actions',
                                cellRenderer: (params) => (
                                    <>

                                        <Button onClick={() => checkConfrimDelete(params?.data)} disabled={isViewPage}>
                                            <DeleteIcon />
                                        </Button>


                                        <Button onClick={(event) => handleDownloadClick(event, params.data)}>
                                            {params?.data?.fileName ? <DownloadIcon /> : <></>}
                                        </Button>
                                    </>
                                ),
                            },
                        ]}
                        setGridApi={setGridApi}
                    />
                </Grid>
                {!isVendorLogin &&
                    <Box sx={{ mt: 3 }}>
                        <ComponentHeader
                            mainHeader={"T&C Details"}
                            statusType='' //to protect from the redux value in the header from WO screen
                        />
                        {isFilledAllMandatoryField && <Typography sx={{ color: "error.main" }}>Please Fill All Mandatory Fields(*)</Typography>}
                        <Grid container spacing={2} >
                            <Grid item xs={12} md={4} sm={6}>
                                <CustomSelectInput
                                    id="tcstatus"
                                    label="T&C status"
                                    defaultValue="option1"
                                    name="istestpassed"
                                    isMandatoryField={true}
                                    error={error?.istestpassed}
                                    errorMessage={errorMessage?.istestpassed}
                                    options={tcstatusOptions}
                                    onChange={handleFieldChange}
                                    value={basicDetailsTC?.istestpassed || ''}
                                    disabled={isViewPage || isDisableAllfileds}
                                />
                            </Grid>

                            <Grid item xs={12} md={4} sm={6}>
                                <CustomDatePicker
                                    label="T&C Completed Date"
                                    id={"testingcommissioncompletedate"}
                                    name="testingcommissioncompletedate"
                                    isMandatoryField={true}
                                    error={error?.testingcommissioncompletedate}
                                    errorMessage={errorMessage?.testingcommissioncompletedate}
                                    value={basicDetailsTC?.testingcommissioncompletedate || ''}
                                    onDateChange={handleFieldChange}
                                    maxDate={currentDate}
                                    disabled={isViewPage || isDisableAllfileds}
                                />
                            </Grid>
                        </Grid>
                        <Modal
                            sx={
                                !isView && {
                                    "& .MuiBackdrop-root": {
                                        backgroundColor: "transparent",
                                    },
                                    top: "-9999px",
                                    left: "-9999px",
                                    zIndex: "-1",
                                }
                            }
                        >
                            <Tcviewfile
                            />
                        </Modal>
                    </Box>
                }
            </form>
            <AssetFooter
                //if vendor login then show submit,save and cancel button
                onPreviousClick={handlePreviousClick}
                continueButtonName="Back"
                previous={true}
                showCancel={true}
                cancelButtonName="Cancel"
                handlCancelClick={() => {
                    if (!isVendorLogin) {
                        navigate('/testingcommission')
                    } else if (isVendorLogin) {
                        navigate('/VendorDashboard')
                    }
                }}
                onAuthorizeClick={handlAuthorizeClick}
                showAuthorize={!isVendorLogin}
                enableAuthorizeButton={isAuthorizeEnabled}
                handlSubmitClick={handleSubmitClick}
                // enableSubmitButton={isSubmitEnabled}
                enableSubmitButton={false}
                showSubmit={true}
                handlConvertToAssetClick={handlConvertToAssetClick}
                showConvertToAsset={accessFemAndBem && !isVendorLogin}
                enableConvetToAssetButton={isConvertToAssetEnabled}
                handleRejectClick={handlRejectClick}
                enableRejectButton={isRejectEnabled}
                showReject={!isVendorLogin}
                showSave={isVendorLogin}
                saveClick={handleSave}
                dataChanged={isDataChanged}
                isVendorLogin={isVendorLogin}
                handleDownloadClick={handleDownloadPDF}
                showDownload={status === "authorized" ? true : false}
            />
            <CustomAlert
                open={openDialog}
                onClose={handleCloseDialog}
                onConfirm={handleCloseDialog}
                content={"Files have been uploaded successfully."}
                confirmBtn='OK'
            />
            <CustomAlert
                open={saveDialog}
                onClose={() => setSaveDialog(false)}
                onConfirm={() => setSaveDialog(false)}
                content={"Data saved successfully."}
                confirmBtn='OK'
            />
            <CustomAlert
                open={openAuthorizeDialog}
                onClose={() => setOpenAuthorizeDialog(false)}
                onConfirm={() => conformAuthorize()}
                content={"Are you sure you want to Authorize?"}
                confirmBtn='YES'
                cancelBtn='NO'
            />
            <CustomAlert
                open={authorizeSuccessDialog}
                onClose={() => setAuthorizeSuccessDialog(false)}
                onConfirm={() => setAuthorizeSuccessDialog(false)}
                content={`${tcDetails?.testingcommissionno} has been Authorized successfully.`}
                confirmBtn='OK'
            />
            <CustomAlert
                open={openRejectDialog}
                onClose={() => setOpenRejectDialog(false)}
                onConfirm={() => conformReject()}
                content={"Are you sure you want to Reject?"}
                confirmBtn='YES'
                cancelBtn='NO'
            />
            <CustomAlert
                open={submitConformationDialog}
                onClose={() => setSubmitConformationDialog(false)}
                onConfirm={() => setSubmitConformationDialog(false)}
                content={`${tcDetails?.testingcommissionno} have been successfully submitted`}
                confirmBtn='OK'
            />
            <CustomAlert
                open={deleteConfrimDialoug}
                onClose={() => {
                    setDeleteConfrimDialoug(false)
                    setCurrentId('');
                }}
                onConfirm={() => {
                    handleDeleteClick(currentId);
                    setDeleteConfrimDialoug(false)
                    setCurrentId('')
                }}
                content={"Are you sure want to delete?"}
                cancelBtn={"NO"}
                confirmBtn={"YES"}
            />
            <CustomAlert
                open={!!errorMessage.others}
                onClose={() => setErrorMessage((prev) => {
                    return { ...prev, others: "" }
                })}
                onConfirm={() => setErrorMessage((prev) => {
                    return { ...prev, others: "" }
                })}
                content={errorMessage.others}
                confirmBtn="Ok"
            />
            {/* <CustomAlert
                open={financeAssetNoError}
                onClose={() => setFinanceAssetNoError(false)}
                onConfirm={() => setFinanceAssetNoError(false)}
                content={<>
                    Before authorizing this T&C (<strong>{basicDetails?.testingcommissionno}</strong>) you need to key in finance asset no first.
                </>}
                confirmBtn="Ok"
            /> */}
        </>
    );
}